import React from 'react';
import Svg, {SvgProps, Path, Rect, G, Defs, ClipPath} from 'react-native-svg';

const NoCollections = (props: SvgProps) => (
  <Svg
    width={250}
    height={200}
    viewBox="0 0 250 200"
    fill="none"
    //@ts-ignore
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M207 65C210.866 65 214 68.134 214 72C214 75.866 210.866 79 207 79H167C170.866 79 174 82.134 174 86C174 89.866 170.866 93 167 93H189C192.866 93 196 96.134 196 100C196 103.866 192.866 107 189 107H178.826C173.952 107 170 110.134 170 114C170 116.577 172 118.911 176 121C179.866 121 183 124.134 183 128C183 131.866 179.866 135 176 135H93C89.134 135 86 131.866 86 128C86 124.134 89.134 121 93 121H54C50.134 121 47 117.866 47 114C47 110.134 50.134 107 54 107H94C97.866 107 101 103.866 101 100C101 96.134 97.866 93 94 93H69C65.134 93 62 89.866 62 86C62 82.134 65.134 79 69 79H109C105.134 79 102 75.866 102 72C102 68.134 105.134 65 109 65H207ZM207 93C210.866 93 214 96.134 214 100C214 103.866 210.866 107 207 107C203.134 107 200 103.866 200 100C200 96.134 203.134 93 207 93Z"
      fill="#F3F7FF"
    />
    <Rect x={124} y={56} width={57} height={57} rx={8} fill="white" />
    <Rect x={85} y={75} width={57} height={57} rx={8} fill="white" />
    <Path
      d="M154.308 85.2081H160.492V82.3699H154.308V76.2446H151.601V82.3699H145.432V85.2081H151.601V91.3478H154.308V85.2081Z"
      fill="#6B9CFE"
    />
    <Path
      d="M141.841 103.338V81.9172C141.841 78.0512 138.707 74.9172 134.841 74.9172H92C88.134 74.9172 85 78.0512 85 81.9172V124.758C85 128.624 88.134 131.758 92 131.758H113.42"
      stroke="#1F64E7"
      strokeWidth={2}
    />
    <Path
      d="M125.159 70.9013L125.159 64C125.159 60.134 128.293 57 132.159 57L175 57C178.866 57 182 60.134 182 64L182 105.605C182 109.471 178.866 112.605 175 112.605L167.79 112.605L160.685 112.605"
      stroke="#6B9CFE"
      strokeLinecap="round"
      strokeDasharray="5 5"
    />
    <Path
      d="M89.3248 81.8405C89.3248 81.0275 90.4469 80.8114 90.7488 81.5663C97.8163 99.235 110.812 113.894 127.506 123.028L131.501 125.215C132.276 125.638 131.975 126.815 131.092 126.815H94.3248C91.5634 126.815 89.3248 124.577 89.3248 121.815V81.8405Z"
      fill="#E5EDFE"
    />
    <G clipPath="url(#clip0_486_6498)">
      <Path
        d="M125.865 108.201C126.882 107.615 128.181 107.963 128.768 108.979L133.284 116.8C133.724 117.563 134.698 117.824 135.461 117.384C136.223 116.944 136.484 115.969 136.044 115.207C135.457 114.19 135.806 112.891 136.822 112.304C137.838 111.717 139.138 112.065 139.725 113.082L140.522 114.462C140.962 115.224 141.936 115.485 142.699 115.045C143.461 114.605 143.722 113.63 143.282 112.868C142.695 111.852 143.043 110.552 144.06 109.965C145.077 109.378 146.375 109.726 146.962 110.742L149.619 115.344C150.059 116.106 151.034 116.368 151.796 115.927C152.558 115.487 152.82 114.513 152.379 113.75C151.793 112.734 152.141 111.434 153.157 110.847C154.174 110.261 155.473 110.609 156.06 111.625L160.705 119.671C161.203 120.534 161.446 121.409 161.384 122.234C161.23 124.289 160.639 127.842 158.546 131.271C155.386 136.451 150.24 139.177 144.169 139.542C141.263 139.716 137.536 138.753 133.735 137.278C129.978 135.821 126.335 133.941 123.656 132.454C121.716 131.377 121.393 129.59 121.956 128.14C122.54 126.638 123.976 125.679 125.723 126.147L131.53 127.703C132.152 127.87 132.814 127.645 133.206 127.133C133.598 126.622 133.644 125.925 133.322 125.367L125.087 111.104C124.501 110.088 124.849 108.788 125.865 108.201ZM133.609 110.989L131.528 107.385C130.061 104.844 126.812 103.974 124.271 105.441C121.731 106.908 120.86 110.157 122.327 112.698L128.638 123.628L126.548 123.068C122.944 122.102 120.045 124.26 118.985 126.985C117.906 129.761 118.632 133.311 122.109 135.241C124.848 136.761 128.634 138.718 132.583 140.25C136.488 141.765 140.744 142.94 144.36 142.723C151.332 142.305 157.493 139.116 161.267 132.931C163.716 128.917 164.387 124.815 164.563 122.473C164.685 120.851 164.194 119.34 163.466 118.077L158.82 110.031C157.353 107.49 154.104 106.62 151.563 108.087C150.909 108.465 150.365 108.961 149.944 109.532L149.722 109.148C148.255 106.606 145.006 105.738 142.466 107.205C141.524 107.749 140.812 108.538 140.363 109.444C138.802 108.624 136.868 108.597 135.228 109.543C134.574 109.921 134.03 110.417 133.609 110.989Z"
        fill="#1F64E7"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_486_6498">
        <Rect
          width={51}
          height={51}
          fill="white"
          transform="translate(105 113.5) rotate(-30)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default NoCollections;
